module.exports = __webpack_public_path__ + "img/itinerary_desktop.0b8de29c.png";